import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ProjectCard } from "./ProjectCard";
import { AnimatedBackground } from "./AnimatedBackground";
import Neptis from "../images/neptis.png";
import Sk4 from "../images/sk4.png";
import Basic from "../images/basic.png";
import Fixpoint from "../images/Fixpoint.png";
import Thinkprompt from "../images/Thinkprompt.png";
import Levelup from "../images/Levelup.png";
import Amedic from "../images/Amedic.png";
import Japan1 from "../images/japan1.jpg";
import Japan2 from "../images/japan2.png";
import Truckers from "../images/truckers.png"
import page from "../images/page.png"
import calculator from "../images/calculator.png"
import robolabs from "../../src/images/robolabs.png"
import sefirix from "../../src/images/sefirix.png"
import salesbuff from "../../src/images/salesbuff.png"
import evolo from "../../src/images/evolo.png"
import webflow1 from "../images/webflow1.png";
import webflow2 from "../images/webflow2.png";
import webflow3 from "../images/webflow3.png";
import webflow4 from "../images/webflow4.png";
import webflow5 from "../images/webflow5.png";
import talpro from "../images/talpro.png";
import shipsigma from "../images/shipsigma.png";
const projects = [
  {
    title: "ShipSigma",
    description:
      "ShipSigma is a SaaS platform that helps businesses analyze, optimize, and manage parcel shipping costs. The platform provides visibility into shipping data, contract performance, and cost drivers across carriers. It is used by operations and logistics teams to make data-backed shipping decisions. I worked as a full stack developer and frontend team lead.",
    image: shipsigma,
    url: "https://shipsigma.com/",
  },
  {
    title: "Neptis Space",
    description:
      "Landing page for coworking space. Modern design with responsive layout and smooth animations.",
    image: Neptis,
    // Replace with actual image URL
    url: "https://neptis.space",
  },
  {
    title: "Sk4Tactic",
    description:
      "Shooting range club info page featuring an intuitive interface and engaging user experience.",
    image: Sk4,
    // Replace with actual image URL
    url: "https://www.sk4tactic.ba/",
  },
  {
    title: "Basić perfomance",
    description:
      "Created with wordpress and custom animations, delivering a unique and dynamic user experience.",
    image: Basic,
    // Replace with actual image URL
    url: "https://basic-performance.com/",
  },

  {
    title: "AmedicLab",
    description:
      "Amediclab d.o.o. Sarajevo specializes in the sale of medical consumables and protective equipment, providing solutions for healthcare professionals. They focus on offering high-quality products for various medical needs.",
    image: Amedic,
    // Replace with actual image URL
    url: "https://www.amediclab.com/",
  },
  {
    title: "Thinkprompt",
    description:
      "ThinkPrompt is an AI interaction platform that enhances user experience with models like ChatGPT. It provides optimized prompt management and shared prompt libraries. I worked on the backend using Strapi, while the frontend was built with React.",
    image: Thinkprompt,
    // Replace with actual image URL
    url: "https://www.thinkprompt.ai/thinkprompt-app",
  },
  {
    title: "FitBy LevelUp",
    description:
      "FitByLevelUp application, which manages the mobile app and allows for adding video workouts and other content. I used Angular for the frontend and .NET for the backend to ensure smooth functionality and integration with the mobile platform.",
    image: Levelup,
    // Replace with actual image URL
    url: "https://fitbylevelup.com/?lang=en",
  },
  {
    title: "JapanAuto",
    description:
      "JapanAuto dashboard is an application for tracking auto parts inventory, employee orders, and payments. Filtering options based on employees, parts, and payment statuses. Developed with React for the frontend and Node.js for the backend.",
    images: [Japan1, Japan2],
    // Replace with actual image URL
    url: "",
  },
  {
    title: "Page-interact",
    description:
      "Page Interact helps businesses bypass Facebook’s 24-hour messaging limit with bulk and one-on-one messaging, automation, and enhanced customer engagement.",
    images: [page],
    // Replace with actual image URL
    url: "",
  },

  {
    title: "Fixpoint",
    description:
      "Fixpoint is a service management app built with React and NestJS. It tracks technician activities, service rates, and device warranties, ensuring efficient service record management.",
    image: Fixpoint,
    // Replace with actual image URL
    url: "",
  },
  {
    title: "Truckers-app",
    description:
      "Truckers App specializes in logistics management software for the trucking industry, offering tools for fleet tracking, route planning, and driver communication to streamline operations.",
    image: Truckers,
    // Replace with actual image URL
    url: "https://www.truckers-app.com",
  },
  {
    title: "OppSearch Cost Calculator",
    description:
      "OPNX is a job search ROI calculator that helps users understand the true cost of staying unemployed. Users enter their salary, hours spent job hunting, and search duration — the tool then calculates.",
    image: calculator,
    // Replace with actual image URL
    url: "https://www.opnx-talent.com/services",
  },
  {
    title: "ROBO Labs Dashboard",
    description:
      "The ROBO platform offers ready-to-use templates for the most common HR documents. All documents are stored on the employee’s profile and archived digitally. ✍🏼 Additionally, you can easily generate reports to see which employees are missing electronic signatures, send reminders.",
    image: robolabs,
    // Replace with actual image URL
    url: "https://www.robolabs.lt/en/system/efficient-document",
  },
  {
    title: "Sefirix",
    description:
   "Developed using React with Vite as the build tool for fast and efficient development, and styled with Tailwind CSS. The design was implemented pixel-perfect, with close attention to detail. The website is fully responsive. Special focus was placed on performance, clean code, and a modular structure.",
    image: sefirix,
    // Replace with actual image URL
    url: "https://www.sefirix.com",
  },
  {
    title: "SalesBuff",
    description:
    'I worked on a custom dashboard for Doing The Most Marketing. The goal was to automate and streamline their client management and internal operations. The platform helped them reduce manual work, improve response times, and centralize key business data, making their daily operations more efficient and scalable.',
   image: salesbuff,
    // Replace with actual image URL
 
  },
  {
    title: "Evolo",
    description:
    "I built the Evolo website using React and Tailwind CSS. It's fully responsive, fast, and deployed on Vercel. The site showcases Evolo’s web services and is designed to drive business growth through clean UI and modern performance.",
   image: evolo,
    // Replace with actual image URL
    url: "https://www.evoloweb.com/",
  },
  {
    title: "Qashio (Webflow)",
    description:
      "Qashio (https://qashio.com) is spend management platform for businesses to manage expenses, payments with integrated corporate cards and accounts payable automation.",
    image: webflow1,
    url: "https://qashio.com",
  },
  {
    title: "The Emerald Company (Webflow)",
    description:
      "The Emerald Company (https://www.emeraldco.io) is building a global luxury brand that combines the heritage of its World-Class mine with cutting-edge innovation. Ovi prave emerald nakit ali imaju i VR prikaz svog nakita.",
    image: webflow2,
    url: "https://www.emeraldco.io",
  },
  {
    title: "Ok-units (Webflow)",
    description:
      "Ok-units (https://www.ok-units.com/) Housing solutions, from Tiny Houses to garden offices and informal care homes.",
    image: webflow3,
    url: "https://www.ok-units.com/",
  },
  {
    title: "XSS Penetration Testing Tool (Webflow)",
    description:
      "(https://store.xss0r.com/) XSS penetration testing tool designed for security professionals.",
    image: webflow4,
    url: "https://store.xss0r.com/",
  },
  {
    title: "Metal.ba (Webflow)",
    description:
      "(https://metal.ba) Production of professional catering equipment",
    image: webflow5,
    url: "https://metal.ba",
  },
  {
    title: "Xceed365 (TalPro Software)",
    description:
      "Xceed365 (now rebranded as TalPro Software) is a comprehensive cloud-based HR management platform designed for mid-sized and large organizations, particularly across Africa.",
    image: talpro,
    url: "https://www.xceed365.com/",
  },
];
export const PortfolioSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  return (
    <section id="projects" className="relative py-20 px-4 overflow-hidden">
      <AnimatedBackground />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 via-blue-900/10 to-purple-900/30 backdrop-blur-3xl" />
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          ref={ref}
          initial={{
            opacity: 0,
            y: 20,
          }}
          animate={
            inView
              ? {
                  opacity: 1,
                  y: 0,
                }
              : {
                  opacity: 0,
                  y: 20,
                }
          }
          transition={{
            duration: 0.8,
          }}
        >
          <div className="text-center mb-16">
            <motion.h2
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={
                inView
                  ? {
                      opacity: 1,
                      y: 0,
                    }
                  : {
                      opacity: 0,
                      y: 20,
                    }
              }
              transition={{
                duration: 0.8,
                delay: 0.2,
              }}
              className="text-4xl sm:text-5xl font-bold relative inline-block"
            >
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                Projects
                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur-sm" />
              </span>
            </motion.h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <motion.div
                key={project.title}
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                animate={
                  inView
                    ? {
                        opacity: 1,
                        y: 0,
                      }
                    : {
                        opacity: 0,
                        y: 20,
                      }
                }
                transition={{
                  duration: 0.5,
                  delay: index * 0.1,
                }}
              >
                <ProjectCard {...project} />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
